export default {
  listTitle: 'Операции',
  detailTitle: 'Операция',
  empty: 'Операции не найдены',
  columns: {
    id: 'ID',
    details: 'Подробно',
    status: 'Статус',
    type: 'Тип',
    description: 'Описание',
    orderId: 'Order ID',
    amount: 'Сумма',
    items: 'Проводки',
    tx: 'Tx',
    errorMessage: 'Ошибка',
    createdAt: 'Создан',
    updatedAt: 'Обновлён',
    step: 'Шаг',
    retries: 'Retries',
  },
  statuses: {
    pending: 'pending',
    processing: 'processing',
    success: 'success',
    completed: 'completed',
    failed: 'failed',
  },
  types: {
    transfer: 'transfer',
    deposit: 'deposit',
    withdraw: 'withdraw',
    topup: 'topup',
    freeze: 'freeze',
    virtual_transfer: 'virtual_transfer',
  },
  filters: {
    operationIdPlaceholder: 'ID операции',
    orderIdPlaceholder: 'Order ID',
    statusAll: 'Все статусы',
    typeAll: 'Все типы',
    reset: 'Сбросить',
  },
  actions: {
    openDetails: 'Подробнее',
    openDetailsNewWindow: 'Открыть в новом окне',
    openTransactions: 'Tx',
    copyId: 'Скопировать ID',
    copyIdSuccess: 'ID скопирован',
    copyIdFailed: 'Не удалось скопировать ID',
  },
  errors: {
    loadList: 'Не удалось загрузить операции',
    loadDetail: 'Не удалось загрузить операцию',
  },
}
